var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeakJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3021 44.6872C7.38625 44.6872 0.132812 37.7668 0.132812 28.2235C0.132812 18.6802 7.38625 11.7598 17.3021 11.7598C27.218 11.7598 34.4714 18.6802 34.4714 28.2235C34.4714 37.7668 27.218 44.6872 17.3021 44.6872Z",
    fill: "#132342"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3026 23.5196C23.1478 23.5196 27.8864 18.2545 27.8864 11.7598C27.8864 5.26504 23.1478 0 17.3026 0C11.4573 0 6.71875 5.26504 6.71875 11.7598C6.71875 18.2545 11.4573 23.5196 17.3026 23.5196Z",
    fill: "url(#paint0_linear_872_27)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_27",
    x1: 29.5432,
    y1: -2.308,
    x2: 12.8955,
    y2: 26.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakJobsIcon);
export default __webpack_public_path__ + "static/media/peak-jobs-icon.87ce7ce78b5192e6f8b0b079e8df536b.svg";
export { ForwardRef as ReactComponent };